import * as React from 'react'

export function Linkedin(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M12.531 11.294v-.033a.985.985 0 0 1-.021.033h.021z" fill="currentColor" />
            <path
                d="M20.529 1.945H2.977c-.84 0-1.521.665-1.521 1.485v17.756c0 .82.681 1.485 1.521 1.485H20.53c.841 0 1.522-.666 1.522-1.485V3.43c0-.82-.681-1.485-1.522-1.485zm-12.83 17.35H4.588V9.936h3.11v9.359zM6.143 8.658h-.02c-1.044 0-1.719-.719-1.719-1.617 0-.918.696-1.617 1.76-1.617s1.719.7 1.74 1.617c0 .898-.676 1.617-1.76 1.617zm12.773 10.637h-3.111v-5.008c0-1.258-.45-2.116-1.575-2.116-.86 0-1.372.579-1.597 1.138-.082.2-.102.479-.102.759v5.227h-3.11s.04-8.482 0-9.36h3.11v1.326c.413-.638 1.153-1.546 2.804-1.546 2.046 0 3.581 1.338 3.581 4.213v5.367z"
                fill="currentColor"
            />
        </svg>
    )
}
